import React from "react";
import { Button } from "react-bootstrap";
import "./commonButton.css";

export default function         CommonButton({
  icon,
  type,
  title,
  disabled,
  className,
  onClick,
  subClassName,
}) {
  return (
    <Button
      variant="link"
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`border-none rounded-2 text-decoration-none common-btn ${className}`}
    >
      <div
        className={`d-flex align-items-center justify-content-center gap-1 ${subClassName}`}
      >
        {icon && <span className="d-flex align-items-center justify-content-center">{icon}</span>}
        {title &&  <div className="fw-medium text-capitalize">{title}</div>}
      </div>
    </Button>
  );
}
